import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tinymce from "tinymce";
import { Editor } from "@tinymce/tinymce-react";
import { getScreenRight } from "utils/generic";
import Button from "components/Button/button";
import { useMaterialUIController } from "context";
import { blank } from "utils/generic";
import { useDispatch } from "react-redux";
import { validateField } from "utils/generic";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { getTemplateById } from "utils/superAdminApi";
import { updateTemplateData } from "utils/superAdminApi";
import { addTemplateData } from "utils/superAdminApi";
const {
  default: DashboardLayout,
} = require("examples/LayoutContainers/DashboardLayout");

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let routePath = "/templates";

let fetchTemplate = {};
let templateSubject = undefined;

function AddTemplate(addProps) {
  const { id } = useParams();

  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [screenName, setScreenName] = useState("Add New Template");
  const [tName, setTName] = useState(false);
  const [tSubject, setTSubject] = useState(false);
  const [tMessage, setTMessage] = useState(false);
  const [inputStatus, setInputStatus] = useState(false);
  const [status, setSatus] = useState(false);
  const [uiVisiblity, SetUivisibility] = useState(true);
  const [uiVisiblity1, SetUivisibility1] = useState(false);
  const [disableColor, setDisableColor] = useState(false);

  const [values, setValues] = React.useState({
    templateStatus: "Active",
    _id: "",
    templateName: "",
    templateType: "Email",
    templateSubject: "",
    templateMessage: "",
  });
  values._id = id;

  const editorRef = useRef(null);
  tinymce.init({
    selector: "#mytextarea",
  });

  const handleChange = (name) => (event) => {
    if (name === "templateType") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "templateStatus") {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity.valid)
      setValues({ ...values, [name]: event.target.value });
    if (event.target.value === "SMS") {
      SetUivisibility(false);
      SetUivisibility1(true);
      setTMessage(false);
      setTName(false);
      setTSubject(false);
    } else if (event.target.value === "Email") {
      values.templateSubject = templateSubject;
      SetUivisibility(true);
      SetUivisibility1(false);
      setTMessage(false);
      setTName(false);
      setTSubject(false);
    }
  };

  useEffect(() => {
    id === undefined
      ? setScreenName("Add New Template")
      : setScreenName("Edit Template");
    (async () => {
      getRight();
      if (id !== undefined) {
        values._id = id;
        setInputStatus(true);
        getTemplateById(
          values,
          (data) => {
            setValues(data.Result_Output[0]);
            fetchTemplate = data.Result_Output[0];
            if (fetchTemplate.templateStatus === "Active") {
              setSatus(true);
            }
            if (fetchTemplate.templateType === "SMS") {
              SetUivisibility1(true);
              SetUivisibility(false);
            } else if (fetchTemplate.templateType === "Email") {
              SetUivisibility(true);
              SetUivisibility1(false);
            }
          },
          dispatch
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  async function getRight() {
    let right = await getScreenRight("Templates");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const clearErrorStates = () => {
    setTName(false);
    setTSubject(false);
    setTMessage(false);
  };

  const addNewTemplate = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.templateName, setTName) || mandateFlag;
    mandateFlag =
      validateField(values.templateSubject, setTSubject) || mandateFlag;
    mandateFlag =
      validateField(values.templateMessage, setTMessage) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addTemplateData : updateTemplateData;
    apiFunction(
      values,
      (data) => {
        if (data.Result_Status) {
          showResMsg(
            id === undefined ? genericMessage.added : genericMessage.updated,
            1000,
            data.Result_Status,
            navigate,
            routePath
          );
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      },
      dispatch
    );
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (e) => {
    const inputElement = document.querySelector(".GoogleInput");
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid
          container
          spacing={1}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item lg={8} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid
                container
                p={1.6}
                mb={0.9}
                px={2}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >
                <Grid item lg={4} xs={12}>
                  <TextField
                    type="text"
                    label="Template Name"
                    variant="outlined"
                    fullWidth
                    value={values.templateName}
                    onChange={handleChange("templateName")}
                    inputProps={{
                      pattern: "^[a-zA-Z0-9 ]+$",
                      maxLength: 60,
                    }}
                    disabled={inputStatus}
                    autoFocus={true}
                  />
                  {tName ? (
                    <span style={errMsg}>Template Name can't be blank</span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="template-type">Template Type</InputLabel>
                    <Select
                      labelId="template-type"
                      id="select-template-type"
                      style={{ minHeight: "44.11px" }}
                      label="Template Type"
                      value={values.templateType}
                      onChange={handleChange("templateType")}
                      disabled={inputStatus}
                    >
                      <MenuItem value="Email">Email</MenuItem>
                      <MenuItem value="SMS">SMS</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="template-status">
                      Template Status
                    </InputLabel>
                    <Select
                      labelId="template-status"
                      id="select-template-status"
                      style={{ minHeight: "44.11px" }}
                      label="Template Status"
                      value={values.templateStatus}
                      onChange={handleChange("templateStatus")}
                      disabled={status}
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {uiVisiblity && (
                  <>
                    <Grid item lg={12} xs={12}>
                      <TextField
                        type="text"
                        label="Template Subject"
                        variant="outlined"
                        fullWidth
                        value={values.templateSubject}
                        onChange={handleChange("templateSubject")}
                        inputProps={{
                          maxLength: 200,
                        }}
                      />
                      {tSubject ? (
                        <span style={errMsg}>
                          Template Subject can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item lg={12} xs={12}>
                      <MDTypography type="label" size={14}>
                        Message Text
                      </MDTypography>
                      <Editor
                        apiKey="your-api-key"
                        maxLength="5000"
                        onEditorChange={(newText) =>
                          (values.templateMessage = newText)
                        }
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        initialValue={values.templateMessage}
                        init={{
                          height: 271,
                          menubar: true,
                          plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste code help wordcount",
                          ],
                          toolbar:
                            "undo redo | formatselect | " +
                            "bold italic backcolor | alignleft aligncenter " +
                            "alignright alignjustify | bullist numlist outdent indent | " +
                            "removeformat | help",
                          content_style:
                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        }}
                      />
                      {tMessage ? (
                        <span style={errMsg}> Message Text can't be blank</span>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </>
                )}
                {uiVisiblity1 && (
                  <Grid item lg={12} xs={12}>
                    <MDInput
                      label="Message Text"
                      multiline
                      rows={5}
                      fullWidth
                      value={values.templateMessage}
                      onChange={handleChange("templateMessage")}
                    />
                    {tMessage ? (
                      <span style={errMsg}> Message Text can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <Link to={"/templates"}>
              <Button
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </Button>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <Button
              rel="noreferrer"
              variant="gradient"
              className={
                "btn-block center-container-btn btn-warning btn-back rightSpace"
              }
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
              onClick={disableColor ? blank : addNewTemplate}
            >
              {id !== undefined ? <>Update</> : <>Save</>}
            </Button>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddTemplate;
